
/**
 * Optimizes an image URL for display.
 * Currently supports Unsplash optimization.
 */
export const optimizeImage = (urlStr: string, width: number = 800): string => {
    if (!urlStr) return '';

    try {
        // Check if it's a relative URL or base64 (skip optimization)
        if (urlStr.startsWith('/') || urlStr.startsWith('data:')) {
            return urlStr;
        }

        const url = new URL(urlStr);

        if (url.hostname === 'images.unsplash.com') {
            url.searchParams.set('auto', 'format');
            url.searchParams.set('fit', 'crop');
            url.searchParams.set('q', '80');
            url.searchParams.set('w', width.toString());
            return url.toString();
        }

        return urlStr;
    } catch (e) {
        // If URL parsing fails, return original
        return urlStr;
    }
};

/**
 * Generates a srcSet string for an image URL.
 */
export const generateSrcSet = (url: string): string => {
    if (!url) return '';

    // Only generate srcset for known optimizable domains
    if (url.includes('images.unsplash.com')) {
        return `${optimizeImage(url, 600)} 600w, ${optimizeImage(url, 800)} 800w, ${optimizeImage(url, 1200)} 1200w`;
    }

    return '';
};
